import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { assetKeys } from '@/lib/assets-api';
import { employeeKeys } from '@/lib/employees-api';

export interface BulkDeleteSkip {
  id: string;
  label: string;
  reason: string;
}

export interface BulkDeleteResult {
  deleted: number;
  /** Everything that was NOT deleted, and why. Together with `deleted` this accounts
   *  for every id sent, so the result can be reconciled against what was selected. */
  skipped: BulkDeleteSkip[];
}

/**
 * POST, not DELETE. A body of ids on a DELETE is poorly supported by proxies and
 * dropped silently by some clients - which would read here as "delete nothing" rather
 * than as an error.
 */
export function useBulkDeleteAssets() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => api.post<BulkDeleteResult>('/assets/bulk-delete', { ids }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: assetKeys.all }),
  });
}

export function useBulkDeleteEmployees() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (ids: string[]) => api.post<BulkDeleteResult>('/employees/bulk-delete', { ids }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: employeeKeys.all }),
  });
}
